var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCreditCardMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.438 12.95H17.061a6.562 6.562 0 0 0-6.562 6.563v10.5a6.562 6.562 0 0 0 6.563 6.562h18.375A6.562 6.562 0 0 0 42 30.013v-10.5a6.562 6.562 0 0 0-6.563-6.563z",
    fill: "url(#lhrmt0xe2a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02 4.2h22.46a8.02 8.02 0 0 1 8.02 8.021v12.833a8.02 8.02 0 0 1-8.02 8.021H8.02A8.02 8.02 0 0 1 0 25.055V12.22a8.02 8.02 0 0 1 8.02-8.02z",
    fill: "url(#5kb2cop9eb)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.427 21.846a2.406 2.406 0 1 1 0 4.812 2.406 2.406 0 0 1 0-4.812z",
    fill: "url(#0k3vqmkasc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.812 12.22h28.875a1.604 1.604 0 0 1 0 3.209H4.812a1.604 1.604 0 1 1 0-3.208z",
    fill: "url(#8h7djmze9d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lhrmt0xe2a",
    x1: 42,
    y1: 12.95,
    x2: 42,
    y2: 36.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0097DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5kb2cop9eb",
    x1: 0,
    y1: 4.2,
    x2: 0,
    y2: 33.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0k3vqmkasc",
    x1: 8.021,
    y1: 21.846,
    x2: 8.021,
    y2: 26.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0097DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8h7djmze9d",
    x1: 3.208,
    y1: 12.221,
    x2: 3.208,
    y2: 15.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0097DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCreditCardMenu);
export default __webpack_public_path__ + "static/media/ic-credit-card-menu.9900459f.svg";
export { ForwardRef as ReactComponent };